module.exports = __webpack_public_path__ + "img/sneek-4.538fef55.jpg";